import * as Yup from 'yup';
import { StepFacilityForm } from './step-facility-types';
import { IrzFacility } from '../../../models';

export function stepFacilitySchema() {
  return Yup.object<StepFacilityForm>().shape({
    irzFacility: Yup.mixed<IrzFacility>().nullable().required('Povinné pole'),
  });
}
